import React, { useCallback, useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import "dayjs/locale/en-gb";
import { FormControlLabel, Checkbox } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Button } from "@mui/material";

function EditPO() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [POReturnData, setPOReturnData] = useState([]);
  const [IndReturnData, setIndReturnData] = useState([]);

  const [poNumber, setpoNumber] = useState("");

  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState("");
  const [poQuantity, setpoQuantity] = useState("");
  const [poDate, setpoDate] = useState(null);
  const [dpDate, setdpDate] = useState(null);
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);
  const [indentNo, setindentNo] = useState("");
  const [qryPOnumber, setqryPOnumber] = useState("");

  const [gemchecked, setgemChecked] = useState(false); // Default is false
    const [gemNumber, setGemNumber] = useState("GEMC-"); 
    const [gemDate, setGemDate] = useState(null);


  const [formData, setFormData] = useState({
    poNumber: "",
    poItemName: "",
    poValue: "",
    poQuantity: "",
    poDate: null,
    dpDate: null,
    gemchecked:false,
    gemNumber:"",
    gemDate:null,
    unit: "",
    indentNo: "",
    partyName: "",
    partyAddress: "",
    partyContact: "",
    selectedOption: "",
    indentConsigneeName: "",

  });
  // Update form field values
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "poQuantity" || field === "poValue") {
      validateField(field, value);
    }
  };
  const [indentConsigneeName, setindentConsigneeName] = useState("");
  const validateField = (field, value) => {
    let error = "";
    if (field === "poQuantity" || field === "poValue") {
      if (!value || isNaN(value) || value <= 0) {
        error = `${field} should be more than zero`;
      }
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.poNumber) newErrors.poNumber = "PO Number is required";
    if (!formData.poItemName) newErrors.poItemName = "Item Name is required";
    if (
      !formData.poQuantity ||
      isNaN(formData.poQuantity) ||
      formData.poQuantity <= 0
    ) {
      newErrors.poQuantity = "Quantity should be more than zero";
    }
    if (!formData.poValue || isNaN(formData.poValue) || formData.poValue <= 0) {
      newErrors.poValue = "Value should be more than zero";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const indentId = useState("");

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const today = dayjs();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;


  

  const consignee= tokenServiceDetails?.consignee || "Unknown Consignee";
  const currentuserrights= tokenServiceDetails?.userrights || [];



// console.log("Consignee from token:", consignee );
// console.log("User Rights from token:", currentuserrights);


  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const [selectedOption, setSelectedOption] = useState("");


  


  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyContact, setPartyContact] = useState("");
  const startRef = useRef(null);



  const handlegemChange = (event) => {
    let inputValue = event.target.value;

    // Ensure the input always starts with "GEMC-"
    if (!inputValue.startsWith("GEMC-")) {
      inputValue = "GEMC-";
    }

    // Restrict to maximum 16 characters
    if (inputValue.length <= 20) {
      setGemNumber(inputValue);
    }
  };



  const handleClose = () => {
    // navigate("../editdata", { replace: true });
    window.location.reload();
  };

  const handleQuantityChange = (value) => {
    setpoQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
      setunit("UNT");
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const handleValueChange = (value) => {
    setpoValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const updatePOData = async () => {
    
    let formErrors = {};

    if (!gemchecked) {  // If gemchecked is false
      setGemNumber(null);
      setGemDate(null);
    }

    if (gemchecked && typeof gemNumber === "string" && gemNumber.trim().length !== 20) {
      formErrors.gemno = "GeM Contract Number length should be exactly 20 characters";
  }

    if (!dpDate) {
      formErrors.errDPDate = "Invalid DP Date";
    }

    if (!poDate) {
      formErrors.errPODate = "Invalid PO Date";
    }

    if (
      !poQuantity ||
      poQuantity.length === 0 ||
      isNaN(parseFloat(poQuantity)) ||
      parseFloat(poQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (!poValue || isNaN(parseFloat(poValue)) || parseFloat(poValue) <= 0) {
      formErrors.val = "Value should be more than zero";
    }

    if (!poNumber || poNumber.length === 0) {
      formErrors.po = "PO Number Should not be Blank";
    }

    if (!poItemName || poItemName.length === 0) {
      formErrors.name = "Item Name Should not be Blank";
    }

    
    if (!selectedOption || selectedOption.length === 0) {
      formErrors.selerr = "Indent Type Not Selected";
    }
    setErrors(formErrors);

    console.log(formErrors);
    if (Object.keys(formErrors).length === 0) {
      const podt = new Date(poDate);
      const ponewdate =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();

      const dpdt = new Date(dpDate);
      const DP_date =
        dpdt.getFullYear() +
        "/" +
        parseInt(dpdt.getMonth() + 1) +
        "/" +
        dpdt.getDate();

        const gemdt = gemchecked ? new Date(gemDate) : null;
        const gem_date = gemdt
          ? `${gemdt.getFullYear()}/${String(gemdt.getMonth() + 1).padStart(2, "0")}/${String(gemdt.getDate()).padStart(2, "0")}`
          : null;

             
          //  console.log(poItemName.substring(0, 500));


      apiClient
        .post("/podataupdate", {
          indentNum: indentNo,
          poNumber,
          poItemName: (poItemName || "").substring(0, 500),
          poQuantity,
          poValue,
          consignee: indentConsigneeName,
          poDate: ponewdate,
          uname,
          dpdate: DP_date,
          ip,
          potype: selectedOption,
          party_name: partyName ? partyName : "",
          party_address: partyAddress ? partyAddress : "",
          party_contact: partyContact ? partyContact : "",
          unit,
          gemtype:gemchecked,
          gemno:gemchecked ? gemNumber:null,
          gemdate:gemchecked? gem_date:null,
        })
        .then(function (response) {
        //  console.log(response.data);
          resetData();
          //navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate PO Not Allowed");
          } else {
            alert(error.response.data.code);
          }
        });
    }
  };








//   const getPOdata = async () => {
//     try {
//       const response = await apiClient.post("/podetails", {
//         indentNumber: poNumber,
//         uname: uname,
//       });
// //console.log(response.data);
//       if (response.status === 201 && response.data?.length > 0) {
//         const poData = response.data[0]; // Use directly
//         setPOReturnData(poData);

//         setindentNo(poData.ind || "");
//         setunit(poData.unit || "");
//         setpoQuantity(poData.quantity || "");
//         setpoValue(poData.value || "");
//         setpoItemName(poData.poitem || "");
//         setSelectedOption(poData.potype || "0");
//         setPartyName(poData.party_name || "");
//         setPartyAddress(poData.party_address || "");
//         setPartyContact(poData.party_contact || "");
//         setpoDate(dayjs(poData.podate || null));
//         setdpDate(dayjs(poData.DPDate || null));
//         setMinCalDate(dayjs(poData.dateofindent || null));
//         setindentConsigneeName(poData.consignee || "");

// setgemChecked(poData.gemtype||false);
// setGemNumber(poData.gemno||"");
// setGemDate(dayjs(poData.gemdate||null));



//       } else {
//         alert("Invalid PO Number");
//       }
//     } catch (error) {
//       // console.error("Error fetching PO data:", err);
//       // alert("Check Entered data then try again.");
//        const errorMsg = error?.response?.data?.message || error.message || "Unknown error occurred";
//        alert("Error fetching data: " + errorMsg);
//       resetData();
//     }
//   };


const getPOdata = async () => {
  try {


    const response = await apiClient.post("/podetails", {
      indentNumber: poNumber, // ensure this is correct
      uname,
    });




    // ✅ New API contract
    if (response.status === 200 && response.data?.success) {
      const poData = response.data.data[0];


// console.log("Received PO Data:", poData);
// console.log("Current User Rights:", currentuserrights);
// console.log("Consignee from PO Data:", poData.consignee);
// console.log("Consignee from Current User Data:", consignee);


if (
  (poData.consignee === consignee &&
  currentuserrights===2 )||
  currentuserrights===1
) {


      setPOReturnData(poData);
      setindentNo(poData.ind || "");
      setunit(poData.unit || "");
      setpoQuantity(poData.quantity || "");
      setpoValue(poData.value || "");
      setpoItemName(poData.POItemName || "");
      setSelectedOption(poData.potype || "0");
      setPartyName(poData.party_name || "");
      setPartyAddress(poData.party_address || "");
      setPartyContact(poData.party_contact || "");
      setpoDate(poData.podate ? dayjs(poData.podate) : null);
      setdpDate(poData.DPDate ? dayjs(poData.DPDate) : null);
      setMinCalDate(poData.dateofindent ? dayjs(poData.dateofindent) : null);
      setindentConsigneeName(poData.consignee || "");
      setgemChecked(Boolean(poData.gemtype));
      setGemNumber(poData.gemno || "");
      setGemDate(poData.gemdate ? dayjs(poData.gemdate) : null);

}
else{
  alert("You are not authorized to edit this PO");
  resetData();
}




    } else {
      alert(response.data?.message || "Invalid PO Number");
      resetData();
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Unknown error occurred";

    alert("Error fetching data: " + errorMsg);
    resetData();
  }
};


  useEffect(() => {
    //getPOdata();
    fetchUnit();
  }, []);

  const resetData = async () => {
    setindentNo(null);
    setpoNumber(null);
    //setunit(POReturnData.unit);
    setpoQuantity(null);
    setpoValue(null);
    setpoItemName(null);
    // setSelectedOption(POReturnData.potype);
    setPartyName(null);
    setPartyAddress(null);
    setPartyContact(null);
    setpoDate(dayjs(null));
    setdpDate(dayjs(null));
    setindentConsigneeName(null);
    setPOReturnData(null);
setgemChecked(false);
setGemDate(dayjs(null));
setGemNumber(null);





  };

  const columns = [
    "PONumber",
    "PODate",
    "DPDate",
    "POItemName",
    "ItemQuantity",
    "ItemValue",
  ];

  const columnNames = [
    "PO Number",
    "PO Date",
    "DP Date",
    "PO ItemName",
    "PO Qty",
    "PO Value",
  ]; // keys from your data objects

  const headers = [
    ["Indent Number", "Indent Item Name", "Consignee"],
    ["Indent date", "Indent Quantity", "Indent Value"],
    ["", "Balance PO Quantity", "Balance PO Value"],
  ];

  const rows = [
    [indentNo, IndReturnData.inditem, IndReturnData.consignee],
    [IndReturnData.inddate, IndReturnData.quantity, IndReturnData.indvalue],
    ["", IndReturnData.POQuantity, IndReturnData.POValue],
  ];

  const menuoptions = [
    { value: "0", label: "Full Indent PO" },
    { value: "1", label: "Partial Indent PO" },
    { value: "2", label: "Final PO of Partial Indent" },
  ];

  const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
  <>
    <style>{`
      .edit-po-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        background: #f4f8fc;
        overflow-x: hidden;
      }

      .edit-po-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #dbe7f3;
        border-radius: 16px;
        box-shadow: 0 6px 22px rgba(13, 71, 161, 0.10);
        overflow: hidden;
      }

      .edit-po-header {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .edit-po-header::before {
        content: "📋";
        font-size: 20px;
      }

      .edit-po-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 20px;
      }

      .edit-po-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 16px;
        margin-bottom: 16px;
        background: #fbfdff;
        border: 1px solid #e0eaf5;
        border-radius: 12px;
      }

      .edit-po-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dce8f5;
        color: #0d47a1;
        font-size: 15px;
        font-weight: 700;
      }

      .edit-po-section-title::before {
        content: "";
        width: 4px;
        height: 20px;
        border-radius: 3px;
        background: linear-gradient(
          180deg,
          #0d47a1,
          #1976d2
        );
      }

      .edit-po-search-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 14px;
        align-items: center;
      }

      .edit-po-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }

      .edit-po-grid-three {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      .edit-po-field {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      .edit-po-field .MuiFormControl-root {
        width: 100%;
        max-width: 100%;
      }

      .edit-po-field .MuiInputBase-root {
        width: 100%;
        max-width: 100%;
        background: #ffffff;
        box-sizing: border-box;
      }

      .edit-po-field .MuiOutlinedInput-root:hover fieldset {
        border-color: #1976d2;
      }

      .edit-po-field .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #1565c0;
        border-width: 2px;
      }

      .edit-po-readonly .MuiInputBase-root {
        background: #f1f5f9;
      }

      .edit-po-search-action {
        min-width: 110px;
      }

      .edit-po-search-button {
        width: 100%;
        min-height: 42px !important;
        border-radius: 8px !important;
        text-transform: none !important;
        font-weight: 700 !important;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        ) !important;
        box-shadow: 0 3px 8px rgba(13, 71, 161, 0.20) !important;
      }

      .edit-po-search-button:hover {
        box-shadow: 0 5px 12px rgba(13, 71, 161, 0.28) !important;
      }

      .edit-po-gem-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        display: grid;
        grid-template-columns:
          minmax(180px, 0.8fr)
          minmax(0, 1fr)
          minmax(0, 1fr);
        gap: 16px;
        align-items: center;
      }

      .edit-po-checkbox {
        min-width: 0;
        padding: 7px 10px;
        border-radius: 8px;
        background: #eef6ff;
        border: 1px solid #d4e5f7;
      }

      .edit-po-checkbox .MuiFormControlLabel-label {
        color: #0d47a1;
        font-size: 14px;
        font-weight: 600;
      }

      .edit-po-item-name {
        width: 100%;
        min-width: 0;
      }

      .edit-po-item-name .MuiInputBase-root {
        align-items: flex-start;
      }

      .edit-po-actions {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        display: flex;
        justify-content: flex-end;
        margin-top: 4px;
      }

      .edit-po-update-button {
        width: 180px;
        max-width: 100%;
        min-height: 44px;
        padding: 10px 20px;
        border: none;
        border-radius: 9px;
        color: #ffffff;
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 10px rgba(13, 71, 161, 0.20);
        transition: all 0.2s ease;
      }

      .edit-po-update-button:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(13, 71, 161, 0.28);
      }

      .edit-po-update-button:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
      }

      @media (max-width: 1000px) {
        .edit-po-gem-section {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        .edit-po-checkbox {
          grid-column: 1 / -1;
        }

        .edit-po-grid-three {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      @media (max-width: 750px) {
        .edit-po-search-grid {
          grid-template-columns: minmax(0, 1fr);
        }

        .edit-po-search-action {
          min-width: 0;
        }

        .edit-po-grid,
        .edit-po-grid-three,
        .edit-po-gem-section {
          grid-template-columns: minmax(0, 1fr);
        }

        .edit-po-checkbox {
          grid-column: auto;
        }
      }

      @media (max-width: 650px) {
        .edit-po-page {
          padding: 8px;
        }

        .edit-po-card {
          border-radius: 12px;
        }

        .edit-po-header {
          padding: 13px 15px;
          font-size: 16px;
        }

        .edit-po-content {
          padding: 12px;
        }

        .edit-po-section {
          padding: 12px;
          margin-bottom: 13px;
        }

        .edit-po-grid,
        .edit-po-grid-three,
        .edit-po-gem-section {
          gap: 13px;
        }

        .edit-po-actions {
          display: block;
        }

        .edit-po-update-button {
          width: 100%;
        }
      }

      @media (max-width: 380px) {
        .edit-po-page {
          padding: 5px;
        }

        .edit-po-content {
          padding: 9px;
        }

        .edit-po-section {
          padding: 10px;
        }

        .edit-po-header {
          font-size: 15px;
        }
      }
    `}</style>

    <div className="edit-po-page">
      <div className="edit-po-card">

        {/* Header */}
        <div className="edit-po-header">
          Edit Purchase Order Data
        </div>

        <div className="edit-po-content">

          {/* Search PO */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              Search Purchase Order
            </div>

            <div className="edit-po-search-grid">

              <div className="edit-po-field">
                <CustomTextField
                  label="PO Number (Max 14 Character)*"
                  value={poNumber || ""}
                  onChange={handleChange}
                  placeholder="PO Number length should be exactly 14 characters"
                  maxLength={14}
                  error={!!errors.po}
                  helperText={errors.po}
                />
              </div>

              <div className="edit-po-search-action">
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={getPOdata}
                  className="edit-po-search-button"
                >
                  Search
                </Button>
              </div>

            </div>
          </div>

          {/* PO Basic Information */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              Purchase Order Information
            </div>

            <div className="edit-po-grid">

              <div className="edit-po-field edit-po-readonly">
                <CustomTextField
                  label="Indent Number"
                  value={indentNo || ""}
                  disabled={true}
                />
              </div>

              <div className="edit-po-field">
                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption || "0"}
                  handleOptionChange={handleOptionChange}
                  error={error}
                  menulabel="Select PO Type"
                />
              </div>

            </div>
          </div>

          {/* GeM Information */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              GeM Contract Information
            </div>

            <div className="edit-po-gem-section">

              <div className="edit-po-checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={gemchecked}
                      onChange={(e) =>
                        setgemChecked(e.target.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Select if GeM Contract"
                />
              </div>

              <div className="edit-po-field">
                <CustomTextField
                  label="GeM Contract Number (Only 20 Character)*"
                  value={gemNumber || ""}
                  onChange={handlegemChange}
                  placeholder="GeM Contract Number length should be exactly 20 characters*"
                  maxLength={20}
                  disabled={!gemchecked}
                />
              </div>

              <div className="edit-po-field">
                <DatePickerComponent
                  label="GeM Contract Date"
                  id="gemdate"
                  value={gemDate}
                  onChange={(newDate) =>
                    setGemDate(newDate || null)
                  }
                  maxDate={today}
                  disabled={!gemchecked}
                />
              </div>

            </div>
          </div>

          {/* PO Item Details */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              PO Item Details
            </div>

            <div className="edit-po-grid-three">

              <div className="edit-po-field">
                <NumericTextField
                  id="ItemQuantity"
                  label="PO Item Quantity"
                  title="PO Item Quantity"
                  error={errors.qty}
                  value={poQuantity || ""}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="edit-po-field">
                <DropdownfromDatabaseList
                  Options={units}
                  option={unit}
                  setOptionValue={setunit}
                  DisplayItem1="unit"
                  DisplayItem2="unitcode"
                  showKeyInLabel={true}
                />
              </div>

              <div className="edit-po-field">
                <NumericTextField
                  id="ItemValue"
                  label="PO Item Value"
                  title="PO Item Value"
                  error={errors.val}
                  value={poValue || ""}
                  onChange={handleValueChange}
                />
              </div>

            </div>
          </div>

          {/* Item Description */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              Item & Party Details
            </div>

            <div className="edit-po-grid">

              <div className="edit-po-field edit-po-item-name">
                <CustomTextField
                  label="Enter Item Name (Max 500 Character)*"
                  value={poItemName || ""}
                  onChange={(e) => {
                    setpoItemName(e.target.value);
                  }}
                  placeholder="Enter Item Name (Max 600 Character)*"
                  maxLength={500}
                  multiline={true}
                  minRows={4}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </div>

              <div className="edit-po-field">
                <CustomTextField
                  label="Party Name (Max 100 Character)*"
                  value={partyName || ""}
                  onChange={(e) => {
                    setPartyName(e.target.value.toUpperCase());
                  }}
                  placeholder="Party Name (Max 100 Character)*"
                  maxLength={100}
                  error={!!errors.partyName}
                  helperText={errors.partyName}
                />
              </div>

              <div className="edit-po-field">
                <CustomTextField
                  label="Party Address (Max 200 Character)*"
                  value={partyAddress || ""}
                  onChange={(e) => {
                    setPartyAddress(e.target.value.toUpperCase());
                  }}
                  placeholder="Party Address (Max 200 Character)*"
                  maxLength={200}
                  error={!!errors.partyAddress}
                  helperText={errors.partyAddress}
                />
              </div>

              <div className="edit-po-field">
                <CustomTextField
                  label="Party Contact Number (Max 10 Character)"
                  value={partyContact || ""}
                  onChange={(e) => {
                    setPartyContact(e.target.value);
                  }}
                  placeholder="Party Contact Number (Max 10 Character)"
                  maxLength={10}
                  error={!!errors.partyContact}
                  helperText={errors.partyContact}
                />
              </div>

            </div>
          </div>

          {/* Dates & Consignee */}
          <div className="edit-po-section">

            <div className="edit-po-section-title">
              PO Dates & Consignee
            </div>

            <div className="edit-po-grid-three">

              <div className="edit-po-field">
                <DatePickerComponent
                  label="PO Date"
                  id="podate"
                  value={poDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setpoDate)
                  }
                  error={errors.errPODate}
                  maxDate={today}
                  minDate={minCalDate}
                />
              </div>

              <div className="edit-po-field">
                <DatePickerComponent
                  label="DP Date"
                  id="dpdate"
                  value={dpDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setdpDate)
                  }
                  error={errors.errDPDate}
                  minDate={poDate ? dayjs(poDate) : minCalDate}
                  disabled={true}
                />
              </div>

              <div className="edit-po-field edit-po-readonly">
                <CustomTextField
                  label="Consignee"
                  value={indentConsigneeName || ""}
                  disabled={true}
                />
              </div>

            </div>
          </div>

          {/* Update */}
          <div className="edit-po-actions">
            <button
              className="edit-po-update-button"
              type="button"
              onClick={updatePOData}
              title="Click for Update Data"
              disabled={!indentNo}
            >
              ✓ Update Data
            </button>
          </div>

        </div>
      </div>
    </div>
  </>
);
}

export default EditPO;
